// import SwiperClass, { Pagination } from "Swiper";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
// SwiperClass.use([Pagination]);

export default VueAwesomeSwiper;
